import React, { useCallback, useMemo } from 'react';

import { classnames } from 'lib/classnames';
import { AUTOMATE_TYPE } from 'lib/constants/automation';
import { useConstantConfig } from 'lib/hooks';
import useI18n from 'lib/hooks/useI18n';
import { ComponentInterface } from 'lib/types/automation';

import NodeContainer from './common/NodeContainer';
import SwitchElement from './SwitchElement';
import { getNodeFromPath } from '.';

import styles from './SwitchComponent.module.less';

const cx = classnames(styles);
const SwitchType: React.FC<ComponentInterface> = props => {
  const { nodes, clickNode, onUpdateNode } = props;
  const { t } = useI18n();
  const { SWITCH_COMPONENT_COMMON_LIST } = useConstantConfig();
  // 节点为分支，则子节点不允许选择分支
  const types = useMemo(() => {
    // 如果第一层的节点是branch，则子孙节点都不可以选择branch类型
    const rootNode = getNodeFromPath(nodes, [clickNode.path[0]]);
    const secondNode = getNodeFromPath(nodes, [clickNode.path[0], clickNode.path[1]]);
    if ([rootNode?.type, secondNode?.type].includes(AUTOMATE_TYPE.BRANCH)) {
      return SWITCH_COMPONENT_COMMON_LIST.filter(k => k.type !== AUTOMATE_TYPE.BRANCH);
    }
    if (rootNode?.type === AUTOMATE_TYPE.CONDITION) {
      return SWITCH_COMPONENT_COMMON_LIST.filter(k => k.type !== AUTOMATE_TYPE.CONDITION);
    }
    return SWITCH_COMPONENT_COMMON_LIST;
  }, [clickNode, nodes]);

  const changeDetails = useCallback(
    component => {
      const { type, title } = component;
      onUpdateNode({ ...clickNode, type, name: title });
    },
    [clickNode, onUpdateNode],
  );

  return (
    <NodeContainer
      title={t('pages.automation.default.view.switch.NodeContainer.title')}
      desc={t('pages.automation.default.view.switch.NodeContainer.desc')}
    >
      <div className={cx('component-list')}>
        {types.map((component, index) => {
          return <SwitchElement onClickNode={changeDetails} element={component} key={index} />;
        })}
      </div>
    </NodeContainer>
  );
};

export default SwitchType;
